import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, SparklesIcon, BookmarkIcon, Share2Icon, XIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { schools } from '../data/mockSchools';
const steps = [{
  q: '意向国家/地区',
  opts: ['英国', '美国', '中国香港', '新加坡', '澳大利亚', '加拿大']
}, {
  q: '学历层次',
  opts: ['本科', '硕士', '博士']
}, {
  q: '专业方向',
  opts: ['计算机', '商科', '工程', '艺术', '社科', '理科']
}, {
  q: '语言水平',
  opts: ['雅思 6.0-6.5', '雅思 7.0+', '托福 90-100', '托福 100+', '暂未考']
}, {
  q: 'GPA 区间',
  opts: ['3.0 以下', '3.0-3.5', '3.5-3.8', '3.8+']
}, {
  q: '预算',
  opts: ['<30万/年', '30-50万/年', '50万+/年']
}, {
  q: '申请时间线',
  opts: ['2026 春', '2026 秋', '2027 春', '2027 秋']
}];
export function AiMatch() {
  const nav = useNavigate();
  const [step, setStep] = useState(0);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const [done, setDone] = useState(false);
  const select = (v: string) => {
    setAnswers({
      ...answers,
      [step]: v
    });
    setTimeout(() => {
      if (step < steps.length - 1) setStep(step + 1);else setDone(true);
    }, 200);
  };
  if (done) return <Report onBack={() => nav('/')} data-id="element-279" />;
  const cur = steps[step];
  const progress = (step + 1) / steps.length * 100;
  return <div className="min-h-screen bg-gradient-to-b from-blue-50 to-white pb-20" data-id="element-280">
      <div className="p-3 flex items-center gap-3" data-id="element-281">
        <button onClick={() => step > 0 ? setStep(step - 1) : nav(-1)} className="p-1" aria-label="返回" data-id="element-282">
          <ChevronLeftIcon data-id="element-283" />
        </button>
        <div className="flex-1 h-1.5 bg-slate-200 rounded-full overflow-hidden" data-id="element-284">
          <motion.div className="h-full bg-blue-600" initial={false} animate={{
          width: `${progress}%`
        }} data-id="element-285" />
        </div>
        <div className="text-xs text-slate-500" data-id="element-286">
          {step + 1}/{steps.length}
        </div>
      </div>

      <div className="px-5 mt-2" data-id="element-287">
        <div className="text-xs text-blue-600 font-semibold flex items-center gap-1" data-id="element-288">
          <SparklesIcon size={14} data-id="element-289" /> AI 选校匹配
        </div>
        <AnimatePresence mode="wait" data-id="element-290">
          <motion.div key={step} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.25
        }} data-id="element-291">
            <h1 className="text-2xl font-extrabold text-slate-900 mt-2" data-id="element-292">
              {cur.q}
            </h1>
            <p className="text-sm text-slate-500 mt-1" data-id="element-293">
              选择最符合你情况的选项
            </p>
            <div className="grid grid-cols-2 gap-3 mt-6" data-id="element-294">
              {cur.opts.map(o => <button key={o} onClick={() => select(o)} className={`h-14 rounded-xl border-2 text-sm font-medium transition ${answers[step] === o ? 'border-blue-600 bg-blue-50 text-blue-700' : 'border-slate-200 bg-white text-slate-700 active:border-blue-400'}`} data-id="element-295">
                  {o}
                </button>)}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>;
}
function Report({
  onBack
}: {
  onBack: () => void;
}) {
  const [poster, setPoster] = useState(false);
  const buckets = [{
    label: '冲刺院校',
    color: 'from-rose-500 to-orange-500',
    list: schools.slice(0, 2),
    data: [{
      match: 78,
      prob: 35,
      pros: ['顶尖排名', '校友网络'],
      cons: ['GPA 偏低', '语言差距']
    }, {
      match: 72,
      prob: 30,
      pros: ['专业强势'],
      cons: ['竞争激烈']
    }]
  }, {
    label: '稳妥院校',
    color: 'from-blue-500 to-cyan-500',
    list: schools.slice(2, 5),
    data: [{
      match: 88,
      prob: 65,
      pros: ['匹配度高'],
      cons: ['学费偏贵']
    }, {
      match: 85,
      prob: 60,
      pros: ['项目优秀'],
      cons: ['地理位置']
    }, {
      match: 82,
      prob: 58,
      pros: ['性价比'],
      cons: ['—']
    }]
  }, {
    label: '保底院校',
    color: 'from-emerald-500 to-teal-500',
    list: schools.slice(5, 8),
    data: [{
      match: 95,
      prob: 90,
      pros: ['稳录取'],
      cons: ['排名一般']
    }, {
      match: 92,
      prob: 88,
      pros: ['高奖学金'],
      cons: ['—']
    }, {
      match: 90,
      prob: 85,
      pros: ['就业好'],
      cons: ['—']
    }]
  }];
  return <div className="min-h-screen bg-slate-50 pb-28" data-id="element-296">
      <div className="p-5 text-white" style={{
      background: 'linear-gradient(135deg,#7C3AED,#3B82F6)'
    }} data-id="element-297">
        <button onClick={onBack} className="text-white/80 text-sm mb-3 flex items-center" aria-label="返回" data-id="element-298">
          <ChevronLeftIcon size={16} data-id="element-299" /> 返回
        </button>
        <div className="text-xs opacity-90 flex items-center gap-1" data-id="element-300">
          <SparklesIcon size={14} data-id="element-301" /> 你的专属 AI 选校报告
        </div>
        <div className="text-2xl font-extrabold mt-1" data-id="element-302">智能匹配完成</div>
        <div className="text-xs opacity-80 mt-1" data-id="element-303">
          基于你的背景与意向，为你筛选 8 所院校
        </div>
      </div>

      <div className="p-3 space-y-4" data-id="element-304">
        {buckets.map(b => <div key={b.label} data-id="element-305">
            <div className={`text-white text-sm font-bold px-3 py-1.5 rounded-lg w-fit bg-gradient-to-r ${b.color} mb-2`} data-id="element-306">
              {b.label}
            </div>
            <div className="space-y-2" data-id="element-307">
              {b.list.map((s, i) => {
            const d = b.data[i];
            return <div key={s.id} className="bg-white rounded-2xl p-3" data-id="element-308">
                    <div className="flex items-center gap-3" data-id="element-309">
                      <div className="w-12 h-12 rounded-lg flex items-center justify-center text-xs font-bold border border-slate-100 shrink-0" style={{
                  background: s.logoBg,
                  color: s.logoColor
                }} data-id="element-310">
                        {s.logoText}
                      </div>
                      <div className="flex-1 min-w-0" data-id="element-311">
                        <div className="font-bold text-sm text-slate-800 truncate" data-id="element-312">
                          {s.cn}
                        </div>
                        <div className="text-[11px] text-slate-500" data-id="element-313">
                          {s.country} · QS #{s.rank}
                        </div>
                      </div>
                      <div className="text-right" data-id="element-314">
                        <div className="text-base font-extrabold text-blue-600" data-id="element-315">
                          {d.match}%
                        </div>
                        <div className="text-[10px] text-slate-500" data-id="element-316">匹配度</div>
                      </div>
                    </div>
                    <div className="mt-2 grid grid-cols-2 gap-2 text-[11px]" data-id="element-317">
                      <div className="bg-emerald-50 rounded-lg p-2" data-id="element-318">
                        <div className="text-emerald-700 font-semibold mb-1" data-id="element-319">
                          优势
                        </div>
                        <div className="flex flex-wrap gap-1" data-id="element-320">
                          {d.pros.map(p => <span key={p} className="bg-white text-emerald-700 px-1.5 py-0.5 rounded" data-id="element-321">
                              {p}
                            </span>)}
                        </div>
                      </div>
                      <div className="bg-rose-50 rounded-lg p-2" data-id="element-322">
                        <div className="text-rose-700 font-semibold mb-1" data-id="element-323">
                          劣势
                        </div>
                        <div className="flex flex-wrap gap-1" data-id="element-324">
                          {d.cons.map(p => <span key={p} className="bg-white text-rose-700 px-1.5 py-0.5 rounded" data-id="element-325">
                              {p}
                            </span>)}
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 text-[11px] text-slate-500" data-id="element-326">
                      预估录取概率{' '}
                      <span className="text-blue-600 font-semibold" data-id="element-327">
                        {d.prob}%
                      </span>
                    </div>
                  </div>;
          })}
            </div>
          </div>)}
      </div>

      <div className="fixed bottom-14 left-1/2 -translate-x-1/2 w-full max-w-[390px] bg-white border-t border-slate-100 p-3 flex gap-2" data-id="element-328">
        <button onClick={() => setPoster(true)} className="flex-1 h-11 rounded-full border border-blue-500 text-blue-600 font-semibold text-sm flex items-center justify-center gap-1" data-id="element-329">
          <BookmarkIcon size={16} data-id="element-330" /> 保存报告
        </button>
        <button onClick={() => toast.success('分享面板已打开')} className="flex-1 h-11 rounded-full bg-blue-600 text-white font-semibold text-sm flex items-center justify-center gap-1" data-id="element-331">
          <Share2Icon size={16} data-id="element-332" /> 分享报告
        </button>
      </div>

      <AnimatePresence data-id="element-333">
        {poster && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-6" onClick={() => setPoster(false)} data-id="element-334">
            <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} exit={{
          scale: 0.9
        }} className="bg-white rounded-2xl w-full max-w-[300px] overflow-hidden relative" onClick={e => e.stopPropagation()} data-id="element-335">
              <button onClick={() => setPoster(false)} className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/20 text-white flex items-center justify-center z-10" aria-label="关闭" data-id="element-336">
                <XIcon size={16} data-id="element-337" />
              </button>
              <div className="p-5 text-white" style={{
            background: 'linear-gradient(135deg,#7C3AED,#3B82F6)'
          }} data-id="element-338">
                <div className="text-xs opacity-90" data-id="element-339">
                  指南者留学 · AI 选校报告
                </div>
                <div className="text-xl font-extrabold mt-1" data-id="element-340">
                  我的留学匹配清单
                </div>
                <div className="text-[11px] opacity-90 mt-1" data-id="element-341">
                  硕士 · 计算机 · 2026秋
                </div>
              </div>
              <div className="p-4 space-y-2" data-id="element-342">
                {schools.slice(0, 4).map(s => <div key={s.id} className="flex items-center gap-2 text-xs" data-id="element-343">
                    <div className="w-6 h-6 rounded text-[8px] font-bold flex items-center justify-center" style={{
                background: s.logoBg,
                color: s.logoColor
              }} data-id="element-344">
                      {s.logoText}
                    </div>
                    <span className="flex-1 text-slate-700" data-id="element-345">{s.cn}</span>
                    <span className="text-blue-600 font-bold" data-id="element-346">
                      {75 + s.rank % 20}%
                    </span>
                  </div>)}
              </div>
              <div className="border-t border-slate-100 p-3 text-center text-[10px] text-slate-400" data-id="element-347">
                长按识别小程序码 · 生成你的专属报告
              </div>
              <div className="px-3 pb-3" data-id="element-348">
                <button onClick={() => {
              toast.success('海报已保存到相册');
              setPoster(false);
            }} className="w-full h-10 rounded-full bg-blue-600 text-white text-sm font-semibold" data-id="element-349">
                  保存到相册
                </button>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}